import React from 'react';

import { TrendCatalogueBlocContainer } from '../../components';
import { TendanceCatalogueProps } from './tendance-catalogue-type';

import enhancer from './tendance-catalogue-enhancer';

import styles from './tendance-catalogue-component.module.css';

const tendanceCatalogue: React.FC<TendanceCatalogueProps> = React.memo(
    ({ products, ...rest }: TendanceCatalogueProps) => {
        return (
            <React.Fragment>
                {products && products.length > 0 ? (
                    <div className={styles.trendBloc}>
                        <TrendCatalogueBlocContainer products={products} {...rest} />
                    </div>
                ) : (
                    ''
                )}
            </React.Fragment>
        );
    },
);

export const TendanceCatalogue = enhancer(tendanceCatalogue);
